import React from "react";
import "./Logo.scss";
const Logo = () => {
  return (
    <section id="logo">
      <div className="container">
        <div className="row">
          <div className="col-lg-2 col-md-6 col-sm-6">
            <div className="logo_box">
              <img
                src="https://f8g8b9p5.rocketcdn.me/themes/forester/wp-content/uploads/2017/03/6.png"
                alt=""
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-6 col-sm-6">
            <div className="logo_box">
              <img
                src="https://f8g8b9p5.rocketcdn.me/themes/forester/wp-content/uploads/2017/03/5.png"
                alt=""
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-6 col-sm-6">
            <div className="logo_box">
              <img
                src="https://f8g8b9p5.rocketcdn.me/themes/forester/wp-content/uploads/2017/03/4.png"
                alt=""
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-6 col-sm-6">
            <div className="logo_box">
              <img
                src="https://f8g8b9p5.rocketcdn.me/themes/forester/wp-content/uploads/2017/03/3.png"
                alt=""
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-6 col-sm-6">
            <div className="logo_box">
              <img
                src="https://f8g8b9p5.rocketcdn.me/themes/forester/wp-content/uploads/2017/03/1.png"
                alt=""
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-6 col-sm-6">
            <div className="logo_box">
              <img
                src="https://f8g8b9p5.rocketcdn.me/themes/forester/wp-content/uploads/2017/03/2.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Logo;
